function UsefulFor({listItems, extra, color}){
    return (
        <div
            className="px-4 py-3 my-4 text-center container-wide box-shadow"
            id="usefulFor"
        >
            <h1 className={`display-5 fw-bold text-body-emphasis quint ${color}`}>
            Javallatok
            </h1>
            {extra}
            <div className="container">
                <div className="row">
                    {
                        listItems.map((group, i) => 
                            <div key={i} className={`col-lg-${12/listItems.length} mx-auto text-start`}>
                                <ul className="list-group list-group-flush">
                                    {group.map((item, i) => 
                                        <li key={i} className={`list-group-item border-${color}`}>
                                            {item}
                                        </li>
                                    )}
                                </ul>
                                <hr className={`hr ${color} m-0 p-0 d-block d-lg-none`} />
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
}

export default UsefulFor;